<template>
  <article class="rc-tile-unit">
    <div class="rc-thumbnail-wrapper">
      <RcImgLazy
        class="img-fluid w-100"
        :src="imgThumbnail(item)"
        alt=""
        aria-hidden="true"
        @error="imageUrlFallback"
      ></RcImgLazy>
    </div>

    <div class="rc-card-body">
      <div class="rc-card-text">
        <header>
          <h3>
            {{ item.title }}
          </h3>
          <div v-if="item.lead" class="d-none d-md-block">
            <div class="rc-summary" v-html="item.lead"></div>
          </div>

          <a
            v-if="item.external_url"
            :href="item.url"
            class="stretched-link"
            :aria-label="
              $t('common.learn_more_about', {
                title: item.title
              })
            "
            @click.prevent=""
            data-bs-toggle="modal"
            data-bs-target="#externalLinkModal"
            @keydown.tab.exact="onKeydownTab"
            @keydown.shift.tab="onKeydownShiftTab"
          >
            <!-- learn_more_about -->
            <span aria-hidden="true">{{ $t("common.learn_more") }}</span>
            <RcIcon name="linkExt" scale=".9"></RcIcon>
          </a>

          <router-link
            v-else
            :to="item.url"
            class="stretched-link"
            :aria-label="
              $t('common.learn_more_about', {
                title: item.title
              })
            "
            @keydown.tab.exact="onKeydownTab"
            @keydown.shift.tab="onKeydownShiftTab"
          >
            <span aria-hidden="true">{{ $t("common.learn_more") }}</span>
            <RcIcon name="arrowRight" scale=".9"></RcIcon>
          </router-link>
        </header>
      </div>
    </div>
  </article>
</template>

<script>
import { catalogItemMixin } from "@/libvue/apps/catalog/mixins/itemMixin";
import RcIcon from "@/libvue/components/icons/Base.vue";
import RcImgLazy from "@/libvue/components/image/ImageLazy.vue";

export default {
  name: "RcTileUnit",
  components: {
    RcIcon,
    RcImgLazy
  },
  mixins: [catalogItemMixin],
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["keydownTab", "keydownShiftTab"],

  methods: {
    onKeydownTab(e) {
      this.$emit("keydownTab", e);
    },
    onKeydownShiftTab(e) {
      this.$emit("keydownShiftTab", e);
    }
  }
};
</script>
<style lang="scss" scoped></style>
